export const asnLookupFieldDropdown =  [
  {
    title: "Shipment ID",
    value: "shipmentId"
  },
  {
    title: "Tracking Number",
    value: "trackingNumber"
  },
  {
    title: "BOL",
    value: "bol"
  },
  {
    title: "Product Name (SKU)",
    value: "productName"
  },
  {
    title: "Origin Location Name",
    value: "originLocationName"
  },
  {
    title: "Quote ID",
    value: "quoteId"
  }
];



// WEBPACK FOOTER //
// ./src/pages/asns/filter/lookupFieldDropdown.js